( function () {
    'use strict';
    e.ecom.productgrid = {};
    e.ecom.productgrid.init = function () {
        if ( jQuery( '.e-ecom-grid' ).length === 1 && jQuery( '.e-productdetails' ).length === 0 ) {
            e.ecom.productlist.sort.init();
            e.ecom.productlist.filter.init();
        }
    };
}() );
